import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const content: SxStyle = {
  height: '100%',
};

export const detailBox: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  background: (p) => p.palette.common.white,
  borderWidth: '1px',
  borderColor: (p) => p.palette.primary[200],
  borderStyle: 'solid',
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5),
  color: (p) => p.palette.primary[500],
  gap: (p) => p.spacing(0.25),
};

export const remainingDaysWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  fontSize: (p) => p.typography.body4.fontSize,

  span: {
    color: (p) => p.palette.common.white,
  },
};

export const remainingBox: SxStyleFunc<boolean | undefined> = (isLow) => ({
  mt: 'auto',
  color: isLow ? (p) => p.palette.warning[700] : (p) => p.palette.common.white,
});

export const detailValue: SxStyleFunc<boolean | undefined> = (isShow) => ({
  display: isShow ? 'flex' : 'none',
});

export const paymentFailed: SxStyle = {
  background: (p) => p.palette.error[100],
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5, 1),
  fontSize: (p) => p.typography.body4.fontSize,
  textAlign: 'center',
};
